import React from "react";
import { Cpu, Handshake, Zap } from "lucide-react";
import { Separator } from "@/components/ui/separator";
export default function WarumS2Automation() {
  const benefits = [{
    title: "Ganzheitliche Integration",
    description: "Von der Planung bis zur Umsetzung: Wir bieten Gebäudeautomation, Energieoptimierung und Steuerungstechnik aus einer Hand.",
    icon: Cpu
  }, {
    title: "Regionales Netzwerk",
    description: "Wir arbeiten eng mit regionalen Elektrofachbetrieben zusammen.\nDie Elektroinstallation erfolgt durch den jeweiligen Partnerbetrieb – S2 Automation übernimmt Planung, Programmierung und Systemintegration.",
    icon: Handshake
  }, {
    title: "Technische Präzision",
    description: "Als zertifizierter Loxone Partner und mit Erfahrung in der Steuerungstechnik stehen wir für saubere, zuverlässige und zukunftssichere Lösungen.",
    icon: Zap
  }];
  return <section id="warum-s2-automation" className="dark bg-background py-20 md:py-28 text-foreground">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 md:gap-0 gap-8">
          {benefits.map((benefit, index) => <div key={index} className="relative flex flex-col items-start px-6 md:px-10" data-index={index}>
              {}
              <div className="mb-5 text-primary">
                <benefit.icon size={32} strokeWidth={1.5} />
              </div>
              
              {}
              <h3 className="mb-3 font-sans text-xl font-bold text-foreground tracking-tight">
                {benefit.title}
              </h3>
              
              {}
              <p className="text-muted-foreground leading-relaxed text-base">
                {benefit.description}
              </p>

              {}
              {index < benefits.length - 1 && <div className="hidden md:block absolute top-0 right-0 h-full w-px py-2">
                   <Separator orientation="vertical" className="h-full bg-border/50" />
                </div>}

              {}
              {index < benefits.length - 1 && <div className="md:hidden w-full pt-8">
                    <Separator orientation="horizontal" className="w-full bg-border/50" />
                 </div>}
            </div>)}
        </div>
      </div>
    </section>;
}